<section class="ref-view">
    <div class="ref-dash-head">
        <div>
            <h1>Referral program overview</h1>
            <p>{{range ? 'Showing the last ' + range + ' days.' : 'How referral partners are bringing in admissions.'}}</p>
        </div>
        <div class="ref-seg" role="group" aria-label="Time range">
            <button type="button" *ngFor="let r of ranges" [class.on]="range === r.v" (click)="setRange(r.v)">{{r.label}}</button>
        </div>
    </div>

    <p *ngIf="loading" class="ref-muted">Loading referral data…</p>
    <p *ngIf="loaded && !loading && !all.length" class="ref-muted">No referrals found yet.</p>

    <ng-container *ngIf="!loading">
        <div class="ref-kpis">
            <div class="ref-kpi ref-ck">
                <div><span>Active partners (30d)</span><b>{{kpi.active}}</b><small>{{kpi.activeSub}}</small></div>
                <div class="ref-cmini">
                    <app-ref-chart *ngIf="charts.partners" [config]="charts.partners" label="Partners by activity"></app-ref-chart>
                </div>
            </div>
            <div class="ref-kpi ref-ck">
                <div>
                    <span>Referrals, last 30 days</span><b>{{kpi.refs}}</b>
                    <small><span [class]="kpi.trend >= 0 ? 'ref-up' : 'ref-down'">{{kpi.trend >= 0 ? '+' : ''}}{{kpi.trend}}%</span> vs previous 30 days</small>
                </div>
                <div class="ref-cmini"><app-ref-chart [config]="charts.spark" label="Referrals, last 30 days"></app-ref-chart></div>
            </div>
            <div class="ref-kpi ref-ck">
                <div><span>Referral to fee paid</span><b>{{kpi.conv}}%</b><small>{{kpi.convSub}}</small></div>
                <div class="ref-cmini"><app-ref-chart [config]="charts.conv" label="Conversion rate"></app-ref-chart></div>
            </div>
            <div class="ref-kpi ref-ck">
                <div><span>Reward points issued</span><b>{{kpi.points}}</b><small>{{kpi.pointsSub}}</small></div>
                <div class="ref-cmini">
                    <app-ref-chart *ngIf="charts.rewards" [config]="charts.rewards" label="Rewards by status"></app-ref-chart>
                </div>
            </div>
        </div>

        <div class="ref-pipe">
            <div class="ref-panel-h" style="margin:0">
                <div>
                    <h2>Admission pipeline</h2>
                    <p>Every referral partners have sent, by how far it got. Click a stage to see those leads.</p>
                </div>
                <span class="ref-pill p-rejected">{{rejected}} rejected · {{closed}} closed</span>
            </div>
            <div class="ref-pipe-row">
                <div class="ref-stage" *ngFor="let s of stages" [style.--c]="s.c" role="button" tabindex="0"
                     (click)="openStage(s.status)" (keydown.enter)="openStage(s.status)" (keydown.space)="$event.preventDefault(); openStage(s.status)">
                    <span>{{s.label}}</span><b>{{s.n}}</b><small>{{s.note}}</small>
                </div>
            </div>
            <div class="ref-drops">
                <div *ngFor="let s of stages; let i = index">
                    <ng-container *ngIf="i > 0">
                        {{stages[i - 1].n ? (s.n / stages[i - 1].n * 100 | number:'1.0-0') : 0}}% moved on,
                        <b>{{stages[i - 1].n - s.n}} dropped or waiting</b>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="ref-grid-2">
            <div class="ref-panel">
                <div class="ref-panel-h"><div><h2>Referrals and conversions</h2><p>Last 6 months, with conversion rate</p></div></div>
                <div class="ref-cbox"><app-ref-chart [config]="charts.monthly" label="Referrals and conversions by month"></app-ref-chart></div>
            </div>
            <div class="ref-panel">
                <div class="ref-panel-h"><div><h2>Where referrals are now</h2><p>Current status of every referral</p></div></div>
                <div class="ref-cbox"><app-ref-chart [config]="charts.status" label="Referrals by status"></app-ref-chart></div>
            </div>
        </div>

        <div class="ref-grid-2">
            <div class="ref-panel">
                <div class="ref-panel-h"><div><h2>Reward points by month</h2><p>Last 6 months</p></div></div>
                <div class="ref-cbox">
                    <app-ref-chart *ngIf="charts.payouts" [config]="charts.payouts" label="Reward points by month"></app-ref-chart>
                    <p *ngIf="!charts.payouts" class="ref-muted">No reward points recorded yet.</p>
                </div>
            </div>
            <div class="ref-panel">
                <div class="ref-panel-h"><div><h2>Needs your attention</h2><p>Work waiting on your team</p></div></div>
                <div class="ref-todo">
                    <button type="button" *ngFor="let t of todos" (click)="openTodo(t)">
                        <span class="n" [style.background]="t.bg" [style.color]="t.fg">{{t.n}}</span>
                        <span><b>{{t.title}}</b><small>{{t.sub}}</small></span>
                        <span class="go">Open</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="ref-panel">
            <div class="ref-panel-h">
                <div><h2>Top partners</h2><p>Fee-paid referrals and other referrals, top 8</p></div>
            </div>
            <div class="ref-cbox tall">
                <app-ref-chart *ngIf="charts.top" [config]="charts.top" label="Top partners"></app-ref-chart>
                <p *ngIf="!charts.top" class="ref-muted">No referrals in this range yet.</p>
            </div>
        </div>

        <div class="ref-panel">
            <div class="ref-panel-h"><div><h2>Recent activity</h2><p>Latest status changes</p></div></div>
            <div class="ref-feed">
                <div *ngFor="let a of feed">
                    <i></i>
                    <span>
                        <b>{{a.referrer}}</b> referred <b>{{a.referred}}</b> — now
                        <span class="ref-pill p-{{(a.statusKey || '').toLowerCase()}}">{{a.statusLabel}}</span>
                    </span>
                    <small>{{ago(a.t)}}</small>
                </div>
                <p *ngIf="!feed.length" class="ref-muted">No activity yet.</p>
            </div>
        </div>
    </ng-container>
</section>
